var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _text, _g13, _g14, _font, _text2, _font2, _text3, _font3, _text4, _font4, _text5, _font5, _text6, _font6, _text7, _font7, _text8, _font8, _text9, _font9, _text10, _font10, _text11, _font11, _text12, _g15, _text13, _g16, _g17, _text14, _font12, _text15, _font13, _text16, _g18, _text17, _g19, _g20, _b, _text18, _font14, _br, _text19, _br2, _text20, _br3, _text21, _br4, _text22, _g21, _text23, _g22, _font15, _text24, _font16, _text25, _font17, _text26, _font18, _text27, _g23, _font19, _text28, _g24, _g25, _g26, _font20, _text29, _font21, _text30, _font22, _text31, _g27, _font23, _text32, _font24, _text33, _font25, _text34, _g28, _text35, _g29, _font26, _text36, _g30, _font27, _text37, _font28, _text38, _font29, _text39, _font30, _text40, _font31, _text41, _font32, _text42, _font33, _text43, _font34, _text44, _font35, _text45, _font36, _text46, _font37, _text47, _font38, _text48, _g31, _text49, _g32, _b2, _text50, _g33, _g34, _b3, _text51, _br5, _text52, _b4, _br6, _text53, _b5, _br7, _text54, _b6, _br8, _text55, _g35, _text56, _g36, _font39, _text57, _font40, _text58, _font41, _text59, _font42, _text60, _g37, _font43, _br9, _text61;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiNativeTransformationdrawio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      background: "transparent",
      backgroundColor: "transparent",
      colorScheme: "light dark"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1469px",
    height: "490px",
    viewBox: "-0.5 -0.5 1469 490",
    content: "<mxfile host=\"app.diagrams.net\" agent=\"Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/134.0.0.0 Safari/537.36\" version=\"26.2.12\" scale=\"1\" border=\"0\"> <diagram name=\"Page-1\" id=\"Jt08yqkyaGZmk6gSez0i\"> <mxGraphModel dx=\"2738\" dy=\"2624\" grid=\"1\" gridSize=\"10\" guides=\"1\" tooltips=\"1\" connect=\"1\" arrows=\"1\" fold=\"1\" page=\"1\" pageScale=\"1\" pageWidth=\"1100\" pageHeight=\"850\" math=\"0\" shadow=\"0\"> <root> <mxCell id=\"0\" /> <mxCell id=\"1\" parent=\"0\" /> <mxCell id=\"2\" value=\"\" style=\"group\" vertex=\"1\" connectable=\"0\" parent=\"1\"> <mxGeometry x=\"-140\" y=\"-1040\" width=\"1468\" height=\"490\" as=\"geometry\" /> </mxCell> <mxCell id=\"3\" value=\"\" style=\"group\" vertex=\"1\" connectable=\"0\" parent=\"2\"> <mxGeometry width=\"720\" height=\"490\" as=\"geometry\" /> </mxCell> <mxCell id=\"4\" value=\"\" style=\"group\" vertex=\"1\" connectable=\"0\" parent=\"3\"> <mxGeometry x=\"140\" y=\"40\" width=\"430\" height=\"390\" as=\"geometry\" /> </mxCell> <mxCell id=\"5\" value=\"\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#EEE2E2;\" vertex=\"1\" parent=\"4\"> <mxGeometry width=\"429.99999999999994\" height=\"390\" as=\"geometry\" /> </mxCell> <mxCell id=\"6\" value=\"\" style=\"group\" vertex=\"1\" connectable=\"0\" parent=\"4\"> <mxGeometry x=\"20.476190476190474\" y=\"230.45454545454544\" width=\"389.04761904761904\" height=\"159.54545454545453\" as=\"geometry\" /> </mxCell> <mxCell id=\"7\" value=\"......\" style=\"text;html=1;strokeColor=none;fillColor=none;align=center;verticalAlign=middle;whiteSpace=wrap;rounded=0;fontFamily=Comic Sans MS;\" vertex=\"1\" parent=\"6\"> <mxGeometry x=\"317.38095238095235\" y=\"97.15909090909088\" width=\"61.42857142857142\" height=\"30.68181818181818\" as=\"geometry\" /> </mxCell> <mxCell id=\"8\" value=\"\" style=\"group\" vertex=\"1\" connectable=\"0\" parent=\"4\"> <mxGeometry x=\"20.47809523809524\" y=\"203.86363636363637\" width=\"399.29\" height=\"182.38704545454542\" as=\"geometry\" /> </mxCell> <mxCell id=\"9\" value=\"\" style=\"group\" vertex=\"1\" connectable=\"0\" parent=\"8\"> <mxGeometry y=\"17.727272727272727\" width=\"399.29\" height=\"164.65977272727272\" as=\"geometry\" /> </mxCell> <mxCell id=\"10\" value=\"\" style=\"shape=document;whiteSpace=wrap;html=1;boundedLbl=1;strokeColor=#0066CC;fontFamily=Comic Sans MS;fontSize=24;fillColor=#FFCCE6;\" vertex=\"1\" parent=\"9\"> <mxGeometry y=\"-17.727272727272727\" width=\"399.29\" height=\"182.38704545454544\" as=\"geometry\" /> </mxCell> <mxCell id=\"11\" value=\"&lt;font face=&quot;poppins&quot;&gt;SEARCH&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#FFFFFF;\" vertex=\"1\" parent=\"9\"> <mxGeometry x=\"20.476190476190474\" y=\"26.591590909090915\" width=\"71.66666666666666\" height=\"20.454545454545453\" as=\"geometry\" /> </mxCell> <mxCell id=\"12\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;Security/RBAC&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;\" vertex=\"1\" parent=\"9\"> <mxGeometry x=\"102.38095238095238\" y=\"26.591590909090915\" width=\"102.38095238095238\" height=\"20.454545454545453\" as=\"geometry\" /> </mxCell> <mxCell id=\"13\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;CMS&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#FFFFFF;\" vertex=\"1\" parent=\"9\"> <mxGeometry x=\"215\" y=\"26.591590909090915\" width=\"51.19047619047619\" height=\"20.454545454545453\" as=\"geometry\" /> </mxCell> <mxCell id=\"14\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;DMS&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#FFFFFF;\" vertex=\"1\" parent=\"9\"> <mxGeometry x=\"284.10714285714283\" y=\"26.591590909090915\" width=\"51.19047619047619\" height=\"20.454545454545453\" as=\"geometry\" /> </mxCell> <mxCell id=\"15\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;Workflows&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#FFFFFF;\" vertex=\"1\" parent=\"9\"> <mxGeometry x=\"20.476190476190474\" y=\"57.27340909090909\" width=\"71.66666666666666\" height=\"20.454545454545453\" as=\"geometry\" /> </mxCell> <mxCell id=\"16\" value=\"&lt;font face=&quot;poppins&quot;&gt;Policy Engine&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#FFFFFF;\" vertex=\"1\" parent=\"9\"> <mxGeometry x=\"102.38095238095238\" y=\"57.27340909090909\" width=\"81.9047619047619\" height=\"20.454545454545453\" as=\"geometry\" /> </mxCell> <mxCell id=\"17\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;ESB&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#FFFFFF;\" vertex=\"1\" parent=\"9\"> <mxGeometry x=\"20.476190476190474\" y=\"93.06886363636364\" width=\"81.9047619047619\" height=\"20.454545454545453\" as=\"geometry\" /> </mxCell> <mxCell id=\"18\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;Catalogue&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#FFFFFF;\" vertex=\"1\" parent=\"9\"> <mxGeometry x=\"209.88095238095238\" y=\"57.27340909090909\" width=\"56.3095238095238\" height=\"20.454545454545453\" as=\"geometry\" /> </mxCell> <mxCell id=\"19\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;Change Central&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#FFFFFF;\" vertex=\"1\" parent=\"9\"> <mxGeometry x=\"296.90476190476187\" y=\"57.27340909090909\" width=\"92.14285714285714\" height=\"20.454545454545453\" as=\"geometry\" /> </mxCell> <mxCell id=\"20\" value=\"&lt;font face=&quot;poppins&quot;&gt;Dataflow&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#FFFFFF;\" vertex=\"1\" parent=\"9\"> <mxGeometry x=\"122.85714285714285\" y=\"87.95522727272727\" width=\"92.14285714285714\" height=\"20.454545454545453\" as=\"geometry\" /> </mxCell> <mxCell id=\"21\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;Lake&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#FFFFFF;\" vertex=\"1\" parent=\"9\"> <mxGeometry x=\"225.2380952380952\" y=\"87.95522727272727\" width=\"92.14285714285714\" height=\"20.454545454545453\" as=\"geometry\" /> </mxCell> <mxCell id=\"22\" value=\"&lt;font face=&quot;poppins&quot; style=&quot;font-size: 12px;&quot;&gt;Common Services -&lt;font color=&quot;#ff230a&quot;&gt;multiple product/component integration&lt;/font&gt;&lt;/font&gt;\" style=\"text;html=1;strokeColor=none;fillColor=none;align=center;verticalAlign=middle;whiteSpace=wrap;rounded=0;fontFamily=Comic Sans MS;fontSize=24;\" vertex=\"1\" parent=\"8\"> <mxGeometry x=\"24.64\" width=\"350\" height=\"26.59090909090909\" as=\"geometry\" /> </mxCell> <mxCell id=\"23\" value=\"\" style=\"group\" vertex=\"1\" connectable=\"0\" parent=\"4\"> <mxGeometry x=\"75.07000000000001\" y=\"44.31818181818181\" width=\"279.85\" height=\"136.0036363636363\" as=\"geometry\" /> </mxCell> <mxCell id=\"24\" value=\"\" style=\"shape=dataStorage;whiteSpace=wrap;html=1;fixedSize=1;strokeColor=#0066CC;fontFamily=Comic Sans MS;fontSize=12;fillColor=#CCFFFF;rotation=90;\" vertex=\"1\" parent=\"23\"> <mxGeometry x=\"58.129999999999995\" y=\"-51.524318181818174\" width=\"153.44\" height=\"239.0522727272727\" as=\"geometry\" /> </mxCell> <mxCell id=\"25\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot; style=&quot;font-size: 12px;&quot;&gt;Business Services -&lt;font color=&quot;#ff1c03&quot;&gt;1 codebase&lt;/font&gt;&amp;nbsp;&lt;/font&gt;\" style=\"text;html=1;strokeColor=none;fillColor=none;align=center;verticalAlign=middle;whiteSpace=wrap;rounded=0;fontFamily=Comic Sans MS;fontSize=24;\" vertex=\"1\" parent=\"23\"> <mxGeometry x=\"29.850000000000023\" y=\"7.303636363636372\" width=\"240\" height=\"30.34022727272727\" as=\"geometry\" /> </mxCell> <mxCell id=\"26\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;Domain Specific Service1&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#FFFFFF;\" vertex=\"1\" parent=\"23\"> <mxGeometry x=\"29.850000000000023\" y=\"37.64386363636366\" width=\"150\" height=\"26.590909090909086\" as=\"geometry\" /> </mxCell> <mxCell id=\"27\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;Domain Specific Service2&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#FFFFFF;\" vertex=\"1\" parent=\"23\"> <mxGeometry x=\"59.85000000000002\" y=\"64.23477272727276\" width=\"150\" height=\"26.590909090909086\" as=\"geometry\" /> </mxCell> <mxCell id=\"28\" value=\"......\" style=\"text;html=1;strokeColor=none;fillColor=none;align=center;verticalAlign=middle;whiteSpace=wrap;rounded=0;fontFamily=Comic Sans MS;\" vertex=\"1\" parent=\"23\"> <mxGeometry x=\"219.85000000000002\" y=\"64.23477272727276\" width=\"60\" height=\"26.590909090909086\" as=\"geometry\" /> </mxCell> <mxCell id=\"29\" style=\"edgeStyle=none;html=1;entryX=-0.021;entryY=0.482;entryDx=0;entryDy=0;entryPerimeter=0;fontFamily=Comic Sans MS;fontSize=24;\" edge=\"1\" parent=\"3\" source=\"5\" target=\"31\"> <mxGeometry relative=\"1\" as=\"geometry\" /> </mxCell> <mxCell id=\"30\" value=\"\" style=\"group\" vertex=\"1\" connectable=\"0\" parent=\"3\"> <mxGeometry x=\"586\" y=\"48\" width=\"90\" height=\"370\" as=\"geometry\" /> </mxCell> <mxCell id=\"31\" value=\"\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#EEE2E2;\" vertex=\"1\" parent=\"30\"> <mxGeometry width=\"90\" height=\"370\" as=\"geometry\" /> </mxCell> <mxCell id=\"32\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot; style=&quot;font-size: 14px;&quot;&gt;&lt;b&gt;Data&lt;/b&gt;&lt;/font&gt;\" style=\"text;html=1;strokeColor=none;fillColor=none;align=center;verticalAlign=middle;whiteSpace=wrap;rounded=0;fontFamily=Comic Sans MS;fontSize=8;\" vertex=\"1\" parent=\"30\"> <mxGeometry x=\"6.75\" y=\"12.613636363636363\" width=\"74.99999999999999\" height=\"25.227272727272727\" as=\"geometry\" /> </mxCell> <mxCell id=\"33\" value=\"&lt;font style=&quot;font-size: 8px;&quot;&gt;&lt;font face=&quot;poppins&quot;&gt;Search&lt;/font&gt;&lt;br&gt;&lt;/font&gt;\" style=\"shape=datastore;whiteSpace=wrap;html=1;strokeColor=#0066CC;fontFamily=Comic Sans MS;fontSize=14;fillColor=#FFCCE6;\" vertex=\"1\" parent=\"30\"> <mxGeometry x=\"21.75\" y=\"42.04545454545454\" width=\"45\" height=\"50.45454545454545\" as=\"geometry\" /> </mxCell> <mxCell id=\"34\" value=\"&lt;font style=&quot;&quot;&gt;&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot; style=&quot;font-size: 6px;&quot;&gt;RELATIONAL&lt;/font&gt;&lt;br&gt;&lt;/font&gt;\" style=\"shape=datastore;whiteSpace=wrap;html=1;strokeColor=#0066CC;fontFamily=Comic Sans MS;fontSize=14;fillColor=#FFCCE6;\" vertex=\"1\" parent=\"30\"> <mxGeometry x=\"22.5\" y=\"117.7272727272727\" width=\"45\" height=\"50.45454545454545\" as=\"geometry\" /> </mxCell> <mxCell id=\"35\" value=\"&lt;font style=&quot;&quot;&gt;&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot; style=&quot;font-size: 6px;&quot;&gt;Cache&lt;/font&gt;&lt;br&gt;&lt;/font&gt;\" style=\"shape=datastore;whiteSpace=wrap;html=1;strokeColor=#0066CC;fontFamily=Comic Sans MS;fontSize=14;fillColor=#FFCCE6;\" vertex=\"1\" parent=\"30\"> <mxGeometry x=\"22.5\" y=\"201.8181818181818\" width=\"45\" height=\"50.45454545454545\" as=\"geometry\" /> </mxCell> <mxCell id=\"36\" value=\"&lt;font style=&quot;&quot;&gt;&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot; style=&quot;font-size: 6px;&quot;&gt;Graph&lt;/font&gt;&lt;br&gt;&lt;/font&gt;\" style=\"shape=datastore;whiteSpace=wrap;html=1;strokeColor=#0066CC;fontFamily=Comic Sans MS;fontSize=14;fillColor=#FFCCE6;\" vertex=\"1\" parent=\"30\"> <mxGeometry x=\"22.5\" y=\"273.2954545454545\" width=\"45\" height=\"50.45454545454545\" as=\"geometry\" /> </mxCell> <mxCell id=\"37\" value=\"&lt;font style=&quot;font-size: 24px;&quot;&gt;.....&lt;/font&gt;\" style=\"text;html=1;strokeColor=none;fillColor=none;align=center;verticalAlign=middle;whiteSpace=wrap;rounded=0;fontFamily=Comic Sans MS;fontSize=6;\" vertex=\"1\" parent=\"30\"> <mxGeometry x=\"36.75\" y=\"332.1590909090909\" width=\"45\" height=\"25.227272727272727\" as=\"geometry\" /> </mxCell> <mxCell id=\"38\" value=\"\" style=\"group\" vertex=\"1\" connectable=\"0\" parent=\"3\"> <mxGeometry x=\"52\" y=\"50\" width=\"80\" height=\"370\" as=\"geometry\" /> </mxCell> <mxCell id=\"39\" value=\"\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#EEE2E2;\" vertex=\"1\" parent=\"38\"> <mxGeometry width=\"80\" height=\"370\" as=\"geometry\" /> </mxCell> <mxCell id=\"40\" value=\"&lt;font face=&quot;poppins&quot;&gt;Mobile client&lt;/font&gt;\" style=\"sketch=0;outlineConnect=0;fontColor=#232F3E;gradientColor=none;strokeColor=#232F3E;fillColor=#EEE2E2;dashed=0;verticalLabelPosition=bottom;verticalAlign=top;align=center;html=1;fontSize=12;fontStyle=0;aspect=fixed;shape=mxgraph.aws4.resourceIcon;resIcon=mxgraph.aws4.mobile_client;fontFamily=Comic Sans MS;\" vertex=\"1\" parent=\"38\"> <mxGeometry x=\"13\" width=\"52.857142857142854\" height=\"52.857142857142854\" as=\"geometry\" /> </mxCell> <mxCell id=\"41\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;Applications&lt;/font&gt;\" style=\"sketch=0;points=[[0,0,0],[0.25,0,0],[0.5,0,0],[0.75,0,0],[1,0,0],[0,1,0],[0.25,1,0],[0.5,1,0],[0.75,1,0],[1,1,0],[0,0.25,0],[0,0.5,0],[0,0.75,0],[1,0.25,0],[1,0.5,0],[1,0.75,0]];outlineConnect=0;fontColor=#232F3E;gradientColor=#F54749;gradientDirection=north;fillColor=#FFCCFF;strokeColor=#ffffff;dashed=0;verticalLabelPosition=bottom;verticalAlign=top;align=center;html=1;fontSize=12;fontStyle=0;aspect=fixed;shape=mxgraph.aws4.resourceIcon;resIcon=mxgraph.aws4.amplify;fontFamily=Comic Sans MS;\" vertex=\"1\" parent=\"38\"> <mxGeometry x=\"18\" y=\"88.09523809523809\" width=\"44.047619047619044\" height=\"44.047619047619044\" as=\"geometry\" /> </mxCell> <mxCell id=\"42\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;Dashboards&lt;/font&gt;\" style=\"sketch=0;points=[[0,0,0],[0.25,0,0],[0.5,0,0],[0.75,0,0],[1,0,0],[0,1,0],[0.25,1,0],[0.5,1,0],[0.75,1,0],[1,1,0],[0,0.25,0],[0,0.5,0],[0,0.75,0],[1,0.25,0],[1,0.5,0],[1,0.75,0]];points=[[0,0,0],[0.25,0,0],[0.5,0,0],[0.75,0,0],[1,0,0],[0,1,0],[0.25,1,0],[0.5,1,0],[0.75,1,0],[1,1,0],[0,0.25,0],[0,0.5,0],[0,0.75,0],[1,0.25,0],[1,0.5,0],[1,0.75,0]];outlineConnect=0;fontColor=#232F3E;gradientColor=#F34482;gradientDirection=north;fillColor=#FFCCFF;strokeColor=#ffffff;dashed=0;verticalLabelPosition=bottom;verticalAlign=top;align=center;html=1;fontSize=12;fontStyle=0;aspect=fixed;shape=mxgraph.aws4.resourceIcon;resIcon=mxgraph.aws4.personal_health_dashboard;fontFamily=Comic Sans MS;\" vertex=\"1\" parent=\"38\"> <mxGeometry x=\"20\" y=\"173.54761904761907\" width=\"38.761904761904766\" height=\"38.761904761904766\" as=\"geometry\" /> </mxCell> <mxCell id=\"43\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;CLI&lt;/font&gt;\" style=\"sketch=0;points=[[0,0,0],[0.25,0,0],[0.5,0,0],[0.75,0,0],[1,0,0],[0,1,0],[0.25,1,0],[0.5,1,0],[0.75,1,0],[1,1,0],[0,0.25,0],[0,0.5,0],[0,0.75,0],[1,0.25,0],[1,0.5,0],[1,0.75,0]];outlineConnect=0;fontColor=#232F3E;gradientColor=#F78E04;gradientDirection=north;fillColor=#D05C17;strokeColor=#ffffff;dashed=0;verticalLabelPosition=bottom;verticalAlign=top;align=center;html=1;fontSize=12;fontStyle=0;aspect=fixed;shape=mxgraph.aws4.resourceIcon;resIcon=mxgraph.aws4.genomics_cli;fontFamily=Comic Sans MS;\" vertex=\"1\" parent=\"38\"> <mxGeometry x=\"19\" y=\"264.2857142857143\" width=\"42.285714285714285\" height=\"42.285714285714285\" as=\"geometry\" /> </mxCell> <mxCell id=\"44\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;Legacy Monolith&lt;/font&gt;\" style=\"text;html=1;strokeColor=none;fillColor=none;align=center;verticalAlign=middle;whiteSpace=wrap;rounded=0;fontFamily=Comic Sans MS;fontSize=24;\" vertex=\"1\" parent=\"3\"> <mxGeometry x=\"215\" y=\"440\" width=\"280\" height=\"50\" as=\"geometry\" /> </mxCell> <mxCell id=\"45\" value=\"\" style=\"group\" vertex=\"1\" connectable=\"0\" parent=\"2\"> <mxGeometry x=\"758\" y=\"40\" width=\"710\" height=\"390\" as=\"geometry\" /> </mxCell> <mxCell id=\"46\" value=\"\" style=\"group\" vertex=\"1\" connectable=\"0\" parent=\"45\"> <mxGeometry x=\"150\" width=\"420\" height=\"390\" as=\"geometry\" /> </mxCell> <mxCell id=\"47\" value=\"\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#EEE2E2;\" vertex=\"1\" parent=\"46\"> <mxGeometry y=\"10\" width=\"420\" height=\"380\" as=\"geometry\" /> </mxCell> <mxCell id=\"48\" value=\"\" style=\"group\" vertex=\"1\" connectable=\"0\" parent=\"46\"> <mxGeometry x=\"20\" y=\"44.31818181818181\" width=\"380\" height=\"70.9090909090909\" as=\"geometry\" /> </mxCell> <mxCell id=\"49\" value=\"\" style=\"group;fillColor=#FFCCCC;container=0;\" vertex=\"1\" connectable=\"0\" parent=\"48\"> <mxGeometry width=\"380\" height=\"70.9090909090909\" as=\"geometry\" /> </mxCell> <mxCell id=\"50\" value=\"&lt;font face=&quot;poppins&quot;&gt;Service Orchestration&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;strokeColor=#0066CC;fillColor=#4DB2FF;\" vertex=\"1\" parent=\"48\"> <mxGeometry x=\"10\" y=\"13.295454545454545\" width=\"90\" height=\"44.31818181818181\" as=\"geometry\" /> </mxCell> <mxCell id=\"51\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;Service Mesh&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#FFFFFF;\" vertex=\"1\" parent=\"48\"> <mxGeometry x=\"110\" y=\"26.59090909090909\" width=\"80\" height=\"17.727272727272727\" as=\"geometry\" /> </mxCell> <mxCell id=\"52\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;Monitoring &amp;amp; Scaling&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;\" vertex=\"1\" parent=\"48\"> <mxGeometry x=\"220\" y=\"26.59090909090909\" width=\"130\" height=\"17.727272727272727\" as=\"geometry\" /> </mxCell> <mxCell id=\"53\" value=\"\" style=\"group\" vertex=\"1\" connectable=\"0\" parent=\"46\"> <mxGeometry x=\"20\" y=\"141.8181818181818\" width=\"380\" height=\"70.9090909090909\" as=\"geometry\" /> </mxCell> <mxCell id=\"54\" value=\"\" style=\"group;fillColor=#CCFFFF;container=0;\" vertex=\"1\" connectable=\"0\" parent=\"53\"> <mxGeometry width=\"380\" height=\"70.9090909090909\" as=\"geometry\" /> </mxCell> <mxCell id=\"55\" value=\"&lt;font face=&quot;poppins&quot;&gt;Business&amp;nbsp;&lt;br&gt;Services&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;strokeColor=#0066CC;fillColor=#4DB2FF;\" vertex=\"1\" parent=\"53\"> <mxGeometry x=\"10\" y=\"13.295454545454545\" width=\"90\" height=\"44.31818181818181\" as=\"geometry\" /> </mxCell> <mxCell id=\"56\" value=\"&lt;font face=&quot;poppins&quot;&gt;Domain Specific Service1&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#FFFFFF;\" vertex=\"1\" parent=\"53\"> <mxGeometry x=\"110\" y=\"8.863636363636363\" width=\"150\" height=\"26.59090909090909\" as=\"geometry\" /> </mxCell> <mxCell id=\"57\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;Domain Specific Service2&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#FFFFFF;\" vertex=\"1\" parent=\"53\"> <mxGeometry x=\"140\" y=\"31.02272727272727\" width=\"150\" height=\"26.59090909090909\" as=\"geometry\" /> </mxCell> <mxCell id=\"58\" value=\"......\" style=\"text;html=1;strokeColor=none;fillColor=none;align=center;verticalAlign=middle;whiteSpace=wrap;rounded=0;fontFamily=Comic Sans MS;\" vertex=\"1\" parent=\"53\"> <mxGeometry x=\"280\" y=\"44.31818181818181\" width=\"60\" height=\"26.59090909090909\" as=\"geometry\" /> </mxCell> <mxCell id=\"59\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;Refactored,&lt;br&gt;Replatformed&lt;/font&gt;\" style=\"text;html=1;strokeColor=none;fillColor=none;align=center;verticalAlign=middle;whiteSpace=wrap;rounded=0;fontFamily=Comic Sans MS;fontSize=12;\" vertex=\"1\" parent=\"53\"> <mxGeometry x=\"320\" y=\"7.532318181818142\" width=\"60\" height=\"29.250000000000004\" as=\"geometry\" /> </mxCell> <mxCell id=\"60\" value=\"\" style=\"group\" vertex=\"1\" connectable=\"0\" parent=\"46\"> <mxGeometry x=\"20\" y=\"248.18181818181816\" width=\"380\" height=\"115.22727272727272\" as=\"geometry\" /> </mxCell> <mxCell id=\"61\" value=\"\" style=\"group;fillColor=#CCFFFF;container=0;\" vertex=\"1\" connectable=\"0\" parent=\"60\"> <mxGeometry width=\"380\" height=\"115.22727272727272\" as=\"geometry\" /> </mxCell> <mxCell id=\"62\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;Common Services&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;strokeColor=#0066CC;fillColor=#4DB2FF;\" vertex=\"1\" parent=\"60\"> <mxGeometry x=\"10\" y=\"35.45454545454545\" width=\"90\" height=\"44.31818181818181\" as=\"geometry\" /> </mxCell> <mxCell id=\"63\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;SEARCH&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#FFFFFF;\" vertex=\"1\" parent=\"60\"> <mxGeometry x=\"110\" y=\"8.863636363636363\" width=\"70\" height=\"17.727272727272727\" as=\"geometry\" /> </mxCell> <mxCell id=\"64\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;Security/RBAC&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;\" vertex=\"1\" parent=\"60\"> <mxGeometry x=\"190\" y=\"8.863636363636363\" width=\"100\" height=\"17.727272727272727\" as=\"geometry\" /> </mxCell> <mxCell id=\"65\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;CMS&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#FFFFFF;\" vertex=\"1\" parent=\"60\"> <mxGeometry x=\"300\" y=\"8.863636363636363\" width=\"50\" height=\"17.727272727272727\" as=\"geometry\" /> </mxCell> <mxCell id=\"66\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;DMS&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#FFFFFF;\" vertex=\"1\" parent=\"60\"> <mxGeometry x=\"110\" y=\"35.45454545454545\" width=\"50\" height=\"17.727272727272727\" as=\"geometry\" /> </mxCell> <mxCell id=\"67\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;Workflows&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#FFFFFF;\" vertex=\"1\" parent=\"60\"> <mxGeometry x=\"170\" y=\"35.45454545454545\" width=\"70\" height=\"17.727272727272727\" as=\"geometry\" /> </mxCell> <mxCell id=\"68\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;Policy Engine&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#FFFFFF;\" vertex=\"1\" parent=\"60\"> <mxGeometry x=\"250\" y=\"35.45454545454545\" width=\"80\" height=\"17.727272727272727\" as=\"geometry\" /> </mxCell> <mxCell id=\"69\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;ESB&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#FFFFFF;\" vertex=\"1\" parent=\"60\"> <mxGeometry x=\"110\" y=\"62.04545454545454\" width=\"80\" height=\"17.727272727272727\" as=\"geometry\" /> </mxCell> <mxCell id=\"70\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;Catalogue&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#FFFFFF;\" vertex=\"1\" parent=\"60\"> <mxGeometry x=\"212.5\" y=\"62.04545454545454\" width=\"55\" height=\"17.727272727272727\" as=\"geometry\" /> </mxCell> <mxCell id=\"71\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;Change Central&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#FFFFFF;\" vertex=\"1\" parent=\"60\"> <mxGeometry x=\"280\" y=\"62.04545454545454\" width=\"90\" height=\"17.727272727272727\" as=\"geometry\" /> </mxCell> <mxCell id=\"72\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;Dataflow&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#FFFFFF;\" vertex=\"1\" parent=\"60\"> <mxGeometry x=\"110\" y=\"88.63636363636363\" width=\"90\" height=\"17.727272727272727\" as=\"geometry\" /> </mxCell> <mxCell id=\"73\" value=\"&lt;font face=&quot;poppins&quot;&gt;Lake&lt;/font&gt;\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#FFFFFF;\" vertex=\"1\" parent=\"60\"> <mxGeometry x=\"210\" y=\"88.63636363636363\" width=\"90\" height=\"17.727272727272727\" as=\"geometry\" /> </mxCell> <mxCell id=\"74\" value=\"......\" style=\"text;html=1;strokeColor=none;fillColor=none;align=center;verticalAlign=middle;whiteSpace=wrap;rounded=0;fontFamily=Comic Sans MS;\" vertex=\"1\" parent=\"60\"> <mxGeometry x=\"310\" y=\"84.20454545454545\" width=\"60\" height=\"26.59090909090909\" as=\"geometry\" /> </mxCell> <mxCell id=\"75\" value=\"&lt;b&gt;&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;Reduced Dependencies&lt;/font&gt;&lt;/b&gt;\" style=\"text;html=1;strokeColor=none;fillColor=none;align=center;verticalAlign=middle;whiteSpace=wrap;rounded=0;fontFamily=Comic Sans MS;fontSize=12;\" vertex=\"1\" parent=\"60\"> <mxGeometry x=\"8\" y=\"-4.436249999999997\" width=\"90\" height=\"29.25\" as=\"geometry\" /> </mxCell> <mxCell id=\"76\" value=\"\" style=\"group\" vertex=\"1\" connectable=\"0\" parent=\"45\"> <mxGeometry x=\"585\" y=\"16.75\" width=\"90\" height=\"358.5\" as=\"geometry\" /> </mxCell> <mxCell id=\"77\" value=\"\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#EEE2E2;\" vertex=\"1\" parent=\"76\"> <mxGeometry x=\"-1\" width=\"90\" height=\"358.5\" as=\"geometry\" /> </mxCell> <mxCell id=\"78\" value=\"&lt;font face=&quot;poppins&quot; data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; style=&quot;font-size: 14px;&quot;&gt;&lt;b&gt;Data&lt;/b&gt;&lt;/font&gt;\" style=\"text;html=1;strokeColor=none;fillColor=none;align=center;verticalAlign=middle;whiteSpace=wrap;rounded=0;fontFamily=Comic Sans MS;fontSize=8;\" vertex=\"1\" parent=\"76\"> <mxGeometry x=\"6.75\" y=\"12.221590909090908\" width=\"75\" height=\"24.443181818181817\" as=\"geometry\" /> </mxCell> <mxCell id=\"79\" value=\"&lt;font style=&quot;&quot;&gt;&lt;b style=&quot;&quot;&gt;&lt;font face=&quot;poppins&quot; style=&quot;font-size: 10px;&quot;&gt;Search&lt;/font&gt;&lt;/b&gt;&lt;br&gt;&lt;/font&gt;\" style=\"shape=datastore;whiteSpace=wrap;html=1;strokeColor=#0066CC;fontFamily=Comic Sans MS;fontSize=14;fillColor=#FFCCE6;\" vertex=\"1\" parent=\"76\"> <mxGeometry x=\"21.75\" y=\"40.73863636363636\" width=\"45\" height=\"48.88636363636363\" as=\"geometry\" /> </mxCell> <mxCell id=\"80\" value=\"&lt;font style=&quot;&quot;&gt;&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot; style=&quot;font-size: 10px;&quot;&gt;&lt;b&gt;NoSql&lt;/b&gt;&lt;/font&gt;&lt;br&gt;&lt;/font&gt;\" style=\"shape=datastore;whiteSpace=wrap;html=1;strokeColor=#0066CC;fontFamily=Comic Sans MS;fontSize=14;fillColor=#FFCCE6;\" vertex=\"1\" parent=\"76\"> <mxGeometry x=\"22.5\" y=\"114.06818181818181\" width=\"45\" height=\"48.88636363636363\" as=\"geometry\" /> </mxCell> <mxCell id=\"81\" value=\"&lt;font style=&quot;&quot;&gt;&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot; style=&quot;font-size: 10px;&quot;&gt;&lt;b&gt;Cache&lt;/b&gt;&lt;/font&gt;&lt;br&gt;&lt;/font&gt;\" style=\"shape=datastore;whiteSpace=wrap;html=1;strokeColor=#0066CC;fontFamily=Comic Sans MS;fontSize=14;fillColor=#FFCCE6;\" vertex=\"1\" parent=\"76\"> <mxGeometry x=\"22.5\" y=\"195.54545454545453\" width=\"45\" height=\"48.88636363636363\" as=\"geometry\" /> </mxCell> <mxCell id=\"82\" value=\"&lt;font style=&quot;&quot;&gt;&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot; style=&quot;font-size: 10px;&quot;&gt;&lt;b&gt;Graph&lt;/b&gt;&lt;/font&gt;&lt;br&gt;&lt;/font&gt;\" style=\"shape=datastore;whiteSpace=wrap;html=1;strokeColor=#0066CC;fontFamily=Comic Sans MS;fontSize=14;fillColor=#FFCCE6;\" vertex=\"1\" parent=\"76\"> <mxGeometry x=\"22.5\" y=\"264.8011363636364\" width=\"45\" height=\"48.88636363636363\" as=\"geometry\" /> </mxCell> <mxCell id=\"83\" value=\"&lt;font style=&quot;font-size: 24px;&quot;&gt;.....&lt;/font&gt;\" style=\"text;html=1;strokeColor=none;fillColor=none;align=center;verticalAlign=middle;whiteSpace=wrap;rounded=0;fontFamily=Comic Sans MS;fontSize=6;\" vertex=\"1\" parent=\"76\"> <mxGeometry x=\"36.75\" y=\"321.83522727272725\" width=\"45\" height=\"24.443181818181817\" as=\"geometry\" /> </mxCell> <mxCell id=\"84\" value=\"\" style=\"group\" vertex=\"1\" connectable=\"0\" parent=\"45\"> <mxGeometry x=\"59\" width=\"80\" height=\"390\" as=\"geometry\" /> </mxCell> <mxCell id=\"85\" value=\"\" style=\"rounded=1;whiteSpace=wrap;html=1;fillColor=#EEE2E2;\" vertex=\"1\" parent=\"84\"> <mxGeometry x=\"1\" y=\"10\" width=\"80\" height=\"380\" as=\"geometry\" /> </mxCell> <mxCell id=\"86\" value=\"&lt;font face=&quot;poppins&quot;&gt;Mobile client&lt;/font&gt;\" style=\"sketch=0;outlineConnect=0;fontColor=#232F3E;gradientColor=none;strokeColor=#232F3E;fillColor=#EEE2E2;dashed=0;verticalLabelPosition=bottom;verticalAlign=top;align=center;html=1;fontSize=12;fontStyle=0;aspect=fixed;shape=mxgraph.aws4.resourceIcon;resIcon=mxgraph.aws4.mobile_client;fontFamily=Comic Sans MS;\" vertex=\"1\" parent=\"84\"> <mxGeometry x=\"12.79\" y=\"30\" width=\"54.418604651162795\" height=\"54.418604651162795\" as=\"geometry\" /> </mxCell> <mxCell id=\"87\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;Applications&lt;/font&gt;\" style=\"sketch=0;points=[[0,0,0],[0.25,0,0],[0.5,0,0],[0.75,0,0],[1,0,0],[0,1,0],[0.25,1,0],[0.5,1,0],[0.75,1,0],[1,1,0],[0,0.25,0],[0,0.5,0],[0,0.75,0],[1,0.25,0],[1,0.5,0],[1,0.75,0]];outlineConnect=0;fontColor=#232F3E;gradientColor=#F54749;gradientDirection=north;fillColor=#FFCCFF;strokeColor=#ffffff;dashed=0;verticalLabelPosition=bottom;verticalAlign=top;align=center;html=1;fontSize=12;fontStyle=0;aspect=fixed;shape=mxgraph.aws4.resourceIcon;resIcon=mxgraph.aws4.amplify;fontFamily=Comic Sans MS;\" vertex=\"1\" parent=\"84\"> <mxGeometry x=\"19.150000000000002\" y=\"119.99767441860465\" width=\"45.348837209302324\" height=\"45.348837209302324\" as=\"geometry\" /> </mxCell> <mxCell id=\"88\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;Dashboards&lt;/font&gt;\" style=\"sketch=0;points=[[0,0,0],[0.25,0,0],[0.5,0,0],[0.75,0,0],[1,0,0],[0,1,0],[0.25,1,0],[0.5,1,0],[0.75,1,0],[1,1,0],[0,0.25,0],[0,0.5,0],[0,0.75,0],[1,0.25,0],[1,0.5,0],[1,0.75,0]];points=[[0,0,0],[0.25,0,0],[0.5,0,0],[0.75,0,0],[1,0,0],[0,1,0],[0.25,1,0],[0.5,1,0],[0.75,1,0],[1,1,0],[0,0.25,0],[0,0.5,0],[0,0.75,0],[1,0.25,0],[1,0.5,0],[1,0.75,0]];outlineConnect=0;fontColor=#232F3E;gradientColor=#F34482;gradientDirection=north;fillColor=#FFCCFF;strokeColor=#ffffff;dashed=0;verticalLabelPosition=bottom;verticalAlign=top;align=center;html=1;fontSize=12;fontStyle=0;aspect=fixed;shape=mxgraph.aws4.resourceIcon;resIcon=mxgraph.aws4.personal_health_dashboard;fontFamily=Comic Sans MS;\" vertex=\"1\" parent=\"84\"> <mxGeometry x=\"21.87\" y=\"220.00162790697675\" width=\"39.906976744186046\" height=\"39.906976744186046\" as=\"geometry\" /> </mxCell> <mxCell id=\"89\" value=\"&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;CLI&lt;/font&gt;\" style=\"sketch=0;points=[[0,0,0],[0.25,0,0],[0.5,0,0],[0.75,0,0],[1,0,0],[0,1,0],[0.25,1,0],[0.5,1,0],[0.75,1,0],[1,1,0],[0,0.25,0],[0,0.5,0],[0,0.75,0],[1,0.25,0],[1,0.5,0],[1,0.75,0]];outlineConnect=0;fontColor=#232F3E;gradientColor=#F78E04;gradientDirection=north;fillColor=#D05C17;strokeColor=#ffffff;dashed=0;verticalLabelPosition=bottom;verticalAlign=top;align=center;html=1;fontSize=12;fontStyle=0;aspect=fixed;shape=mxgraph.aws4.resourceIcon;resIcon=mxgraph.aws4.genomics_cli;fontFamily=Comic Sans MS;\" vertex=\"1\" parent=\"84\"> <mxGeometry x=\"18.240000000000002\" y=\"310.00162790697675\" width=\"43.53488372093023\" height=\"43.53488372093023\" as=\"geometry\" /> </mxCell> <mxCell id=\"90\" value=\"&lt;font style=&quot;font-size: 24px;&quot;&gt;&lt;font data-font-src=&quot;https://fonts.googleapis.com/css?family=poppins&quot; face=&quot;poppins&quot;&gt;Cloud Native&lt;/font&gt;&lt;br&gt;&lt;/font&gt;\" style=\"text;html=1;strokeColor=none;fillColor=none;align=center;verticalAlign=middle;whiteSpace=wrap;rounded=0;fontFamily=Comic Sans MS;fontSize=12;\" vertex=\"1\" parent=\"2\"> <mxGeometry x=\"940\" y=\"435\" width=\"330\" height=\"40\" as=\"geometry\" /> </mxCell> </root> </mxGraphModel> </diagram>\n</mxfile>\n",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "0%",
    y2: "0%",
    id: "drawio-svg-MqirY2T3EYL537KwJXKP-gradient-light-dark_f54749_ff7072_-1-light-dark_ffccff_512551_-1-s-0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFCCFF",
    stopOpacity: 1,
    style: {
      stopColor: "light-dark(rgb(255, 204, 255), rgb(81, 37, 81))",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F54749",
    stopOpacity: 1,
    style: {
      stopColor: "light-dark(rgb(245, 71, 73), rgb(255, 112, 114))",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "0%",
    y2: "0%",
    id: "drawio-svg-MqirY2T3EYL537KwJXKP-gradient-light-dark_f34482_ff6ba1_-1-light-dark_ffccff_512551_-1-s-0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFCCFF",
    stopOpacity: 1,
    style: {
      stopColor: "light-dark(rgb(255, 204, 255), rgb(81, 37, 81))",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F34482",
    stopOpacity: 1,
    style: {
      stopColor: "light-dark(rgb(243, 68, 130), rgb(255, 107, 161))",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "0%",
    y2: "0%",
    id: "drawio-svg-MqirY2T3EYL537KwJXKP-gradient-light-dark_f78e04_b85e00_-1-light-dark_d05c17_e07c41_-1-s-0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#D05C17",
    stopOpacity: 1,
    style: {
      stopColor: "light-dark(rgb(208, 92, 23), rgb(224, 124, 65))",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F78E04",
    stopOpacity: 1,
    style: {
      stopColor: "light-dark(rgb(247, 142, 4), rgb(184, 94, 0))",
      stopOpacity: 1
    }
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "@import url(https://fonts.googleapis.com/css2?family=poppins:wght@400;500);&#xa;"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": 0
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": 1
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "82dtt1fWFMic4u1b7Cw8-5"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-1"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-3"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-4"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-5"
  })), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-6"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-8"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-9"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-10"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-11"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-12"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-13"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-14"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-15"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-16"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-17"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-18"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-19"
  })), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-20"
  })), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-21"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-22"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-23"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-24"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-25"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-26"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-27"
  })), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-28"
  })), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-29"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-30"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-32"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-33"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-34"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-35"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-36"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-37"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-38"
  })), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-1"
  })), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-39"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-40"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-41"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-42"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-43"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-44"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-45"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-46"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-47"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-48"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-49"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-50"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-51"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-52"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-53"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-54"
  })), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-57"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-58"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-59"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-60"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-61"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-62"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-63"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-64"
  })), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-65"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-66"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-67"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-68"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-69"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-70"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-71"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-72"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "x2zNfU1buflAoCDAem4x-78"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-1"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-2"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-3"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-4"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-5"
  })), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-6"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-8"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-9"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-10"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-11"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-12"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-13"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-14"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-15"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-16"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-17"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-18"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-19"
  })), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-20"
  })), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-31"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-33"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-34"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-35"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-36"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-37"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-38"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-39"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-40"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-41"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-42"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-43"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-44"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-45"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-46"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-47"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-48"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-49"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-50"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-51"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-52"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-53"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-54"
  })), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-55"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-57"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-58"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-59"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-60"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-61"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-62"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-63"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-64"
  })), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-65"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-66"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-67"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-68"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-69"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-70"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-71"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-72"
  })), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-73"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-78"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "TM2PQ_vUnSsz5HXXXiUI-79"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-3"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-21"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-39"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-40"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-41"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-42"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-43"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-44"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-45"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-46"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-47"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-48"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-49"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-50"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-51"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-52"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-53"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-54"
  })), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-64"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-65"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-66"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-67"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-68"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-69"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-70"
  })), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "EUy_UJlJhRMQavqHQtzr-1"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "EUy_UJlJhRMQavqHQtzr-8"
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "EUy_UJlJhRMQavqHQtzr-2"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "EUy_UJlJhRMQavqHQtzr-7"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "EUy_UJlJhRMQavqHQtzr-12"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-59"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-60"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "EUy_UJlJhRMQavqHQtzr-9"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-61"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-58"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-33"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-38"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-35"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-36"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "Id-aAk-NPcWM76Ev4NFU-37"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "EUy_UJlJhRMQavqHQtzr-10"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "EUy_UJlJhRMQavqHQtzr-11"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "EUy_UJlJhRMQavqHQtzr-13"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "EUy_UJlJhRMQavqHQtzr-14"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "EUy_UJlJhRMQavqHQtzr-16"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "EUy_UJlJhRMQavqHQtzr-17"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "EUy_UJlJhRMQavqHQtzr-18"
  }), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "EUy_UJlJhRMQavqHQtzr-19"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "JAH7sVyCV3_5cxgfEnHs-1"
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "82dtt1fWFMic4u1b7Cw8-1"
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-1"
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 40,
    width: 430,
    height: 390,
    rx: 58.5,
    ry: 58.5,
    fill: "#eee2e2",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(238, 226, 226), rgb(49, 38, 38))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-3"
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-4"
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 476.86,
    y: 367.61,
    width: 61.43,
    height: 30.68,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 59,
      height: 1,
      paddingTop: 383,
      marginLeft: 478
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "......")))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 508,
    y: 387,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "......"))))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-6"
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-7"
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-8"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 159.48 243.86 L 558.77 243.86 L 558.77 398.89 Q 458.95 349.65 359.12 398.89 Q 259.3 448.14 159.48 398.89 L 159.48 271.22 Z",
    fill: "#ffcce6",
    stroke: "#0066cc",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 204, 230), rgb(84, 40, 63))",
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-9"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 179.95,
    y: 288.18,
    width: 71.67,
    height: 20.45,
    rx: 3.07,
    ry: 3.07,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 70,
      height: 1,
      paddingTop: 298,
      marginLeft: 181
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font || (_font = /*#__PURE__*/React.createElement("font", {
    face: "poppins"
  }, "SEARCH")))))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 216,
    y: 302,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "SEARCH")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-10"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 261.86,
    y: 288.18,
    width: 102.38,
    height: 20.45,
    rx: 3.07,
    ry: 3.07,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(#ffffff, var(--ge-dark-color, #121212))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 100,
      height: 1,
      paddingTop: 298,
      marginLeft: 263
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font2 || (_font2 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Security/RBAC")))))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 313,
    y: 302,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Security/RBAC")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-11"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 374.48,
    y: 288.18,
    width: 51.19,
    height: 20.45,
    rx: 3.07,
    ry: 3.07,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 49,
      height: 1,
      paddingTop: 298,
      marginLeft: 375
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font3 || (_font3 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "CMS")))))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 302,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "CMS")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-12"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 443.59,
    y: 288.18,
    width: 51.19,
    height: 20.45,
    rx: 3.07,
    ry: 3.07,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 49,
      height: 1,
      paddingTop: 298,
      marginLeft: 445
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font4 || (_font4 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "DMS")))))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 469,
    y: 302,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "DMS")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-13"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 179.95,
    y: 318.86,
    width: 71.67,
    height: 20.45,
    rx: 3.07,
    ry: 3.07,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 70,
      height: 1,
      paddingTop: 329,
      marginLeft: 181
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font5 || (_font5 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Workflows")))))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 216,
    y: 333,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Workflows")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-14"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 261.86,
    y: 318.86,
    width: 81.9,
    height: 20.45,
    rx: 3.07,
    ry: 3.07,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 80,
      height: 1,
      paddingTop: 329,
      marginLeft: 263
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font6 || (_font6 = /*#__PURE__*/React.createElement("font", {
    face: "poppins"
  }, "Policy Engine")))))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 303,
    y: 333,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Policy Engine")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-15"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 179.95,
    y: 354.66,
    width: 81.9,
    height: 20.45,
    rx: 3.07,
    ry: 3.07,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 80,
      height: 1,
      paddingTop: 365,
      marginLeft: 181
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font7 || (_font7 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "ESB")))))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 221,
    y: 368,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "ESB")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-16"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 369.36,
    y: 318.86,
    width: 56.31,
    height: 20.45,
    rx: 3.07,
    ry: 3.07,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 54,
      height: 1,
      paddingTop: 329,
      marginLeft: 370
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font8 || (_font8 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Catalogue")))))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 398,
    y: 333,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Catalogue")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-17"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 456.38,
    y: 318.86,
    width: 92.14,
    height: 20.45,
    rx: 3.07,
    ry: 3.07,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 90,
      height: 1,
      paddingTop: 329,
      marginLeft: 457
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font9 || (_font9 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Change Central")))))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 502,
    y: 333,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Change Central")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-18"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 282.34,
    y: 349.55,
    width: 92.14,
    height: 20.45,
    rx: 3.07,
    ry: 3.07,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 90,
      height: 1,
      paddingTop: 360,
      marginLeft: 283
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font10 || (_font10 = /*#__PURE__*/React.createElement("font", {
    face: "poppins"
  }, "Dataflow")))))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 328,
    y: 363,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Dataflow")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 384.72,
    y: 349.55,
    width: 92.14,
    height: 20.45,
    rx: 3.07,
    ry: 3.07,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 90,
      height: 1,
      paddingTop: 360,
      marginLeft: 386
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font11 || (_font11 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Lake")))))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 431,
    y: 363,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Lake"))))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-20"
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 184.12,
    y: 243.86,
    width: 350,
    height: 26.59,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 348,
      height: 1,
      paddingTop: 257,
      marginLeft: 185
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 24,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    },
    face: "poppins"
  }, "Common Services -", /*#__PURE__*/React.createElement("font", {
    color: "#ff230a",
    style: {
      color: "light-dark(rgb(255, 35, 10), rgb(255, 130, 108))"
    }
  }, "multiple product/component integration")))))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 359,
    y: 264,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "24px",
    textAnchor: "middle"
  }, "Common Services -multiple pro..."))))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-21"
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-22"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 292.2 32.79 L 425.64 32.79 Q 385.64 152.32 425.64 271.85 L 292.2 271.85 Q 252.2 152.32 292.2 32.79 Z",
    fill: "#ccffff",
    stroke: "#0066cc",
    strokeMiterlimit: 10,
    transform: "rotate(90,348.92,152.32)",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(204, 255, 255), rgb(0, 37, 37))",
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-23"
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 243.92,
    y: 91.62,
    width: 240,
    height: 30.34,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 238,
      height: 1,
      paddingTop: 107,
      marginLeft: 245
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 24,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 12
    },
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Business Services -", /*#__PURE__*/React.createElement("font", {
    color: "#ff1c03",
    style: {
      color: "light-dark(rgb(255, 28, 3), rgb(255, 133, 111))"
    }
  }, "1 codebase")))))), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 364,
    y: 114,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "24px",
    textAnchor: "middle"
  }, "Business Services -1...")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-24"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 243.92,
    y: 121.96,
    width: 150,
    height: 26.59,
    rx: 3.99,
    ry: 3.99,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 148,
      height: 1,
      paddingTop: 135,
      marginLeft: 245
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font12 || (_font12 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Domain Specific Service1")))))), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 319,
    y: 139,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Domain Specific Service1")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-25"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 273.92,
    y: 148.55,
    width: 150,
    height: 26.59,
    rx: 3.99,
    ry: 3.99,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 148,
      height: 1,
      paddingTop: 162,
      marginLeft: 275
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font13 || (_font13 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Domain Specific Service2")))))), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 349,
    y: 165,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Domain Specific Service2")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-26"
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 433.92,
    y: 148.55,
    width: 60,
    height: 26.59,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 58,
      height: 1,
      paddingTop: 162,
      marginLeft: 435
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "......")))), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 464,
    y: 165,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "......")))))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-31"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 569 226.87 L 576.75 226.58",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 581.99 226.38 L 575.13 230.14 L 576.75 226.58 L 574.87 223.15 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-34"
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-35"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 585,
    y: 48,
    width: 90,
    height: 370,
    rx: 13.5,
    ry: 13.5,
    fill: "#eee2e2",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(238, 226, 226), rgb(49, 38, 38))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-36"
  }, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 591.75,
    y: 60.61,
    width: 75,
    height: 25.23,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 73,
      height: 1,
      paddingTop: 73,
      marginLeft: 593
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 8,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 14
    },
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, _b || (_b = /*#__PURE__*/React.createElement("b", null, "Data"))))))), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 629,
    y: 76,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "8px",
    textAnchor: "middle"
  }, "Data")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-37"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 606.75 96.05 C 606.75 88.05 651.75 88.05 651.75 96.05 L 651.75 134.5 C 651.75 142.5 606.75 142.5 606.75 134.5 Z",
    fill: "#ffcce6",
    stroke: "#0066cc",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 204, 230), rgb(84, 40, 63))",
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 606.75 96.05 C 606.75 102.05 651.75 102.05 651.75 96.05 M 606.75 99.05 C 606.75 105.05 651.75 105.05 651.75 99.05 M 606.75 102.05 C 606.75 108.05 651.75 108.05 651.75 102.05",
    fill: "none",
    stroke: "#0066cc",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 43,
      height: 1,
      paddingTop: 124,
      marginLeft: 608
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 8
    }
  }, _font14 || (_font14 = /*#__PURE__*/React.createElement("font", {
    face: "poppins"
  }, "Search")), _br || (_br = /*#__PURE__*/React.createElement("br", null))))))), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 629,
    y: 128,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "14px",
    textAnchor: "middle"
  }, "Search&#xa;")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-38"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 607.5 171.73 C 607.5 163.73 652.5 163.73 652.5 171.73 L 652.5 210.18 C 652.5 218.18 607.5 218.18 607.5 210.18 Z",
    fill: "#ffcce6",
    stroke: "#0066cc",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 204, 230), rgb(84, 40, 63))",
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 607.5 171.73 C 607.5 177.73 652.5 177.73 652.5 171.73 M 607.5 174.73 C 607.5 180.73 652.5 180.73 652.5 174.73 M 607.5 177.73 C 607.5 183.73 652.5 183.73 652.5 177.73",
    fill: "none",
    stroke: "#0066cc",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 43,
      height: 1,
      paddingTop: 200,
      marginLeft: 609
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {}
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 6
    },
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "RELATIONAL"), _br2 || (_br2 = /*#__PURE__*/React.createElement("br", null))))))), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 204,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "14px",
    textAnchor: "middle"
  }, "RELATI...")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-39"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 607.5 255.82 C 607.5 247.82 652.5 247.82 652.5 255.82 L 652.5 294.27 C 652.5 302.27 607.5 302.27 607.5 294.27 Z",
    fill: "#ffcce6",
    stroke: "#0066cc",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 204, 230), rgb(84, 40, 63))",
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 607.5 255.82 C 607.5 261.82 652.5 261.82 652.5 255.82 M 607.5 258.82 C 607.5 264.82 652.5 264.82 652.5 258.82 M 607.5 261.82 C 607.5 267.82 652.5 267.82 652.5 261.82",
    fill: "none",
    stroke: "#0066cc",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 43,
      height: 1,
      paddingTop: 284,
      marginLeft: 609
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {}
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 6
    },
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Cache"), _br3 || (_br3 = /*#__PURE__*/React.createElement("br", null))))))), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 288,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "14px",
    textAnchor: "middle"
  }, "Cache&#xa;")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 607.5 327.3 C 607.5 319.3 652.5 319.3 652.5 327.3 L 652.5 365.75 C 652.5 373.75 607.5 373.75 607.5 365.75 Z",
    fill: "#ffcce6",
    stroke: "#0066cc",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 204, 230), rgb(84, 40, 63))",
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 607.5 327.3 C 607.5 333.3 652.5 333.3 652.5 327.3 M 607.5 330.3 C 607.5 336.3 652.5 336.3 652.5 330.3 M 607.5 333.3 C 607.5 339.3 652.5 339.3 652.5 333.3",
    fill: "none",
    stroke: "#0066cc",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 43,
      height: 1,
      paddingTop: 355,
      marginLeft: 609
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {}
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 6
    },
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Graph"), _br4 || (_br4 = /*#__PURE__*/React.createElement("br", null))))))), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 360,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "14px",
    textAnchor: "middle"
  }, "Graph&#xa;")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-41"
  }, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 621.75,
    y: 380.16,
    width: 45,
    height: 25.23,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 43,
      height: 1,
      paddingTop: 393,
      marginLeft: 623
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 6,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 24
    }
  }, "....."))))), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 644,
    y: 395,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "6px",
    textAnchor: "middle"
  }, "....."))))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-43"
  }, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-44"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 50,
    width: 80,
    height: 370,
    rx: 12,
    ry: 12,
    fill: "#eee2e2",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(238, 226, 226), rgb(49, 38, 38))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-45"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 64 50 L 116.86 50 L 116.86 102.86 L 64 102.86 Z",
    fill: "#eee2e2",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(238, 226, 226), rgb(49, 38, 38))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 86.19 59.25 C 86.36 59.25 86.49 59.38 86.49 59.55 C 86.49 59.71 86.36 59.84 86.19 59.84 C 86.03 59.84 85.9 59.71 85.9 59.55 C 85.9 59.38 86.03 59.25 86.19 59.25 Z M 86.19 61.29 C 87.15 61.29 87.94 60.51 87.94 59.55 C 87.94 58.59 87.15 57.8 86.19 57.8 C 85.23 57.8 84.45 58.59 84.45 59.55 C 84.45 60.51 85.23 61.29 86.19 61.29 Z M 89.48 60.5 L 94.66 60.5 L 94.66 58.57 L 89.48 58.57 Z M 98.32 95.64 L 82.54 95.64 C 81.57 95.64 80.79 94.87 80.79 93.93 L 80.79 92.57 L 100.07 92.57 L 100.07 93.93 C 100.07 94.87 99.28 95.64 98.32 95.64 Z M 80.79 63.78 L 100.07 63.78 L 100.07 90.64 L 80.79 90.64 L 80.79 81.28 Z M 83.34 57.22 L 97.52 57.22 C 98.92 57.22 100.07 58.34 100.07 59.72 L 100.07 61.85 L 80.79 61.85 L 80.79 59.72 C 80.79 58.34 81.93 57.22 83.34 57.22 Z M 97.53 55.29 L 97.52 55.29 L 83.34 55.29 C 80.87 55.29 78.86 57.28 78.86 59.72 L 78.86 93.93 C 78.86 95.94 80.51 97.57 82.54 97.57 L 98.32 97.57 C 100.35 97.57 102 95.94 102 93.93 L 102 59.72 L 102 59.72 C 102 57.28 100 55.29 97.53 55.29 Z",
    fill: "#232f3e",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(35, 47, 62), rgb(189, 199, 212))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 110,
      marginLeft: 90
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#232F3E"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#232F3E, #bdc7d4)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, _font15 || (_font15 = /*#__PURE__*/React.createElement("font", {
    face: "poppins"
  }, "Mobile client")))))), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 122,
    fill: "#232F3E",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Mobile cl...")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-46"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 69 138.1 L 113.05 138.1 L 113.05 182.14 L 69 182.14 Z",
    fill: "url(#drawio-svg-MqirY2T3EYL537KwJXKP-gradient-light-dark_f54749_ff7072_-1-light-dark_ffccff_512551_-1-s-0)",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "url(&quot"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 103.34 172.42 L 90.71 147.81 L 94.33 147.81 L 106.96 172.42 Z M 108.54 172.77 L 95.27 146.9 C 95.16 146.69 94.95 146.56 94.71 146.56 L 89.69 146.56 C 89.47 146.56 89.26 146.67 89.15 146.86 C 89.04 147.04 89.03 147.28 89.13 147.47 L 102.4 173.34 C 102.51 173.55 102.72 173.68 102.96 173.68 L 107.98 173.68 C 108.2 173.68 108.41 173.57 108.52 173.38 C 108.63 173.19 108.64 172.96 108.54 172.77 Z M 95.8 172.42 L 86.13 154.3 L 88.11 151.03 L 99.4 172.42 Z M 88.71 149.46 C 88.6 149.26 88.39 149.13 88.17 149.13 C 87.95 149.11 87.73 149.24 87.61 149.43 L 84.87 153.96 C 84.76 154.15 84.75 154.38 84.86 154.58 L 94.87 173.35 C 94.98 173.55 95.19 173.68 95.42 173.68 L 100.45 173.68 C 100.67 173.68 100.87 173.57 100.98 173.38 C 101.1 173.19 101.1 172.95 101 172.76 Z M 75.18 172.42 L 84.04 157.76 L 85.85 161.15 L 81.69 168.34 C 81.57 168.54 81.57 168.77 81.68 168.97 C 81.8 169.16 82 169.28 82.23 169.28 L 90.19 169.28 L 91.86 172.42 Z M 91.12 168.36 C 91.01 168.16 90.79 168.03 90.56 168.03 L 83.32 168.03 L 87.11 161.48 C 87.22 161.29 87.22 161.06 87.12 160.87 L 84.63 156.2 C 84.52 156 84.32 155.87 84.09 155.86 C 83.85 155.85 83.66 155.97 83.54 156.17 L 73.53 172.73 C 73.41 172.92 73.4 173.16 73.52 173.36 C 73.63 173.56 73.84 173.68 74.06 173.68 L 92.91 173.68 C 93.13 173.68 93.33 173.57 93.45 173.38 C 93.56 173.19 93.57 172.95 93.46 172.76 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 189,
      marginLeft: 91
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#232F3E"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#232F3E, #bdc7d4)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, _font16 || (_font16 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Applications")))))), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 91,
    y: 201,
    fill: "#232F3E",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Applica...")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-47"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 71 223.55 L 109.76 223.55 L 109.76 262.31 L 71 262.31 Z",
    fill: "url(#drawio-svg-MqirY2T3EYL537KwJXKP-gradient-light-dark_f34482_ff6ba1_-1-light-dark_ffccff_512551_-1-s-0)",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "url(&quot"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 74.88 244.64 L 76.02 244.64 L 76.02 243.49 L 74.88 243.49 Z M 94.95 234.71 C 94.87 234.47 94.65 234.31 94.4 234.31 L 94.4 234.31 C 94.15 234.31 93.93 234.47 93.85 234.71 L 90.24 246.05 L 86.87 239.78 C 86.77 239.59 86.58 239.48 86.37 239.47 L 86.36 239.47 C 86.16 239.47 85.96 239.58 85.86 239.76 L 83.73 243.49 L 77.17 243.49 L 77.17 244.64 L 84.06 244.64 C 84.27 244.64 84.46 244.53 84.56 244.35 L 86.35 241.23 L 89.88 247.78 C 89.98 247.97 90.17 248.09 90.38 248.09 C 90.4 248.09 90.42 248.09 90.43 248.08 C 90.66 248.06 90.86 247.91 90.93 247.69 L 94.4 236.79 L 96.72 244.24 C 96.8 244.48 97.02 244.64 97.27 244.64 L 105.89 244.64 L 105.89 243.49 L 97.69 243.49 Z M 90.38 256.34 L 82.12 245.67 L 81.21 246.37 L 89.93 257.63 C 90.04 257.77 90.19 257.87 90.38 257.85 C 90.56 257.85 90.72 257.77 90.83 257.63 L 99.62 246.37 L 98.71 245.67 Z M 75.86 239.52 C 75.2 238.3 74.88 237.09 74.88 235.86 C 74.88 231.52 78.49 227.99 82.94 227.99 C 86.49 227.99 89.24 229.6 90.38 232.12 C 91.52 229.6 94.27 227.99 97.82 227.99 C 102.27 227.99 105.89 231.52 105.89 235.86 C 105.89 237.06 105.57 238.26 104.95 239.44 C 104.77 239.78 104.54 240.13 104.27 240.49 L 103.77 241.09 L 102.29 242.73 L 101.44 241.96 L 103.38 239.78 C 103.59 239.49 103.78 239.19 103.93 238.9 C 104.47 237.89 104.74 236.87 104.74 235.86 C 104.74 232.15 101.64 229.14 97.82 229.14 C 94.4 229.14 90.96 230.91 90.96 234.88 C 90.96 235.2 90.7 235.45 90.38 235.45 C 90.06 235.45 89.81 235.2 89.81 234.88 C 89.81 230.91 86.36 229.14 82.94 229.14 C 79.13 229.14 76.02 232.15 76.02 235.86 C 76.02 236.89 76.3 237.93 76.85 238.94 L 78.81 241.99 L 77.84 242.61 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 269,
      marginLeft: 90
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#232F3E"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#232F3E, #bdc7d4)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, _font17 || (_font17 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Dashboards")))))), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 281,
    fill: "#232F3E",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Dashbo...")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-48"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 70 314.29 L 112.29 314.29 L 112.29 356.57 L 70 356.57 Z",
    fill: "url(#drawio-svg-MqirY2T3EYL537KwJXKP-gradient-light-dark_f78e04_b85e00_-1-light-dark_d05c17_e07c41_-1-s-0)",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "url(&quot"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 99.69 323.99 L 104.35 323.99 L 104.35 322.79 L 99.69 322.79 Z M 99 320.89 L 105.04 320.89 L 105.04 319.68 L 99 319.68 Z M 99.6 337.24 L 104.43 337.24 L 104.43 336.03 L 99.6 336.03 Z M 99 340.26 L 105.04 340.26 L 105.04 339.05 L 99 339.05 Z M 87.34 339.48 C 87.58 339.24 87.58 338.86 87.34 338.63 L 80.09 331.38 L 79.24 332.23 L 86.06 339.05 L 79.24 345.87 L 80.09 346.73 Z M 87.52 346.3 L 99.6 346.3 L 99.6 345.09 L 87.52 345.09 Z M 108.06 351.13 L 108.06 345.09 L 106.85 345.09 L 106.85 351.13 L 75.44 351.13 L 75.44 319.72 L 92.35 319.72 L 92.35 318.51 L 75.44 318.51 C 74.77 318.51 74.23 319.06 74.23 319.72 L 74.23 351.13 C 74.23 351.8 74.77 352.34 75.44 352.34 L 106.85 352.34 C 107.52 352.34 108.06 351.8 108.06 351.13 Z M 97.18 338.88 C 97.18 337.06 97.87 335.32 99.11 333.99 L 105.81 326.82 C 107.26 325.26 108.06 323.23 108.06 321.11 L 108.06 318.51 L 106.85 318.51 L 106.85 321.11 C 106.85 322.92 106.16 324.67 104.92 325.99 L 98.23 333.17 C 96.77 334.72 95.98 336.75 95.98 338.88 L 95.98 341.47 L 97.18 341.47 Z M 103.67 330.88 L 102.84 331.76 L 104.92 333.99 C 106.16 335.32 106.85 337.06 106.85 338.88 L 106.85 341.47 L 108.06 341.47 L 108.06 338.88 C 108.06 336.75 107.26 334.72 105.81 333.17 Z M 98.23 326.82 C 96.77 325.26 95.98 323.23 95.98 321.11 L 95.98 318.51 L 97.18 318.51 L 97.18 321.11 C 97.18 322.92 97.87 324.67 99.11 325.99 L 101.19 328.22 L 100.36 329.11 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 364,
      marginLeft: 91
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#232F3E"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#232F3E, #bdc7d4)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, _font18 || (_font18 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "CLI")))))), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    x: 91,
    y: 376,
    fill: "#232F3E",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "CLI"))))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "pwxfyV8NG3vbBgJ1mFDp-5"
  }, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 214,
    y: 440,
    width: 280,
    height: 50,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 278,
      height: 1,
      paddingTop: 465,
      marginLeft: 215
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 24,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font19 || (_font19 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Legacy Monolith")))))), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    x: 354,
    y: 472,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "24px",
    textAnchor: "middle"
  }, "Legacy Monolith"))))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-1"
  }, _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-2"
  }, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 907,
    y: 50,
    width: 420,
    height: 380,
    rx: 57,
    ry: 57,
    fill: "#eee2e2",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(238, 226, 226), rgb(49, 38, 38))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-4"
  }, _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 927,
    y: 84.32,
    width: 380,
    height: 70.91,
    fill: "#ffcccc",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 204, 204), rgb(87, 43, 43))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 937,
    y: 97.61,
    width: 90,
    height: 44.32,
    rx: 6.65,
    ry: 6.65,
    fill: "#4db2ff",
    stroke: "#0066cc",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(77, 178, 255), rgb(24, 111, 177))",
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 88,
      height: 1,
      paddingTop: 120,
      marginLeft: 938
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font20 || (_font20 = /*#__PURE__*/React.createElement("font", {
    face: "poppins"
  }, "Service Orchestration")))))), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    x: 982,
    y: 123,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Service Orchest...")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1037,
    y: 110.91,
    width: 80,
    height: 17.73,
    rx: 2.66,
    ry: 2.66,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 120,
      marginLeft: 1038
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font21 || (_font21 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Service Mesh")))))), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    x: 1077,
    y: 123,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Service Mesh")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-8"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1147,
    y: 110.91,
    width: 130,
    height: 17.73,
    rx: 2.66,
    ry: 2.66,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(#ffffff, var(--ge-dark-color, #121212))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 128,
      height: 1,
      paddingTop: 120,
      marginLeft: 1148
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font22 || (_font22 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Monitoring &amp; Scaling")))))), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    x: 1212,
    y: 123,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Monitoring &amp; Scaling"))))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-9"
  }, _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-10"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 927,
    y: 181.82,
    width: 380,
    height: 70.91,
    fill: "#ccffff",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(204, 255, 255), rgb(0, 37, 37))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-11"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 937,
    y: 195.11,
    width: 90,
    height: 44.32,
    rx: 6.65,
    ry: 6.65,
    fill: "#4db2ff",
    stroke: "#0066cc",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(77, 178, 255), rgb(24, 111, 177))",
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 88,
      height: 1,
      paddingTop: 217,
      marginLeft: 938
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font23 || (_font23 = /*#__PURE__*/React.createElement("font", {
    face: "poppins"
  }, "Business\xA0", /*#__PURE__*/React.createElement("br", null), "Services")))))), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    x: 982,
    y: 221,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Business...")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-12"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1037,
    y: 190.68,
    width: 150,
    height: 26.59,
    rx: 3.99,
    ry: 3.99,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 148,
      height: 1,
      paddingTop: 204,
      marginLeft: 1038
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font24 || (_font24 = /*#__PURE__*/React.createElement("font", {
    face: "poppins"
  }, "Domain Specific Service1")))))), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    x: 1112,
    y: 208,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Domain Specific Service1")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-13"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1067,
    y: 212.84,
    width: 150,
    height: 26.59,
    rx: 3.99,
    ry: 3.99,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 148,
      height: 1,
      paddingTop: 226,
      marginLeft: 1068
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font25 || (_font25 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Domain Specific Service2")))))), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    x: 1142,
    y: 230,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Domain Specific Service2")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-14"
  }, _g28 || (_g28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1207,
    y: 226.14,
    width: 60,
    height: 26.59,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 58,
      height: 1,
      paddingTop: 239,
      marginLeft: 1208
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "......")))), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
    x: 1237,
    y: 243,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "......")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-15"
  }, _g29 || (_g29 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1247,
    y: 189.35,
    width: 60,
    height: 29.25,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 58,
      height: 1,
      paddingTop: 204,
      marginLeft: 1248
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font26 || (_font26 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Refactored,", /*#__PURE__*/React.createElement("br", null), "Replatformed")))))), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
    x: 1277,
    y: 208,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Refactored..."))))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-16"
  }, _g30 || (_g30 = /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-17"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 927,
    y: 288.18,
    width: 380,
    height: 115.23,
    fill: "#ccffff",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(204, 255, 255), rgb(0, 37, 37))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-18"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 937,
    y: 323.64,
    width: 90,
    height: 44.32,
    rx: 6.65,
    ry: 6.65,
    fill: "#4db2ff",
    stroke: "#0066cc",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(77, 178, 255), rgb(24, 111, 177))",
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 88,
      height: 1,
      paddingTop: 346,
      marginLeft: 938
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font27 || (_font27 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Common Services")))))), _text37 || (_text37 = /*#__PURE__*/React.createElement("text", {
    x: 982,
    y: 349,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Common Services")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1037,
    y: 297.05,
    width: 70,
    height: 17.73,
    rx: 2.66,
    ry: 2.66,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 68,
      height: 1,
      paddingTop: 306,
      marginLeft: 1038
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font28 || (_font28 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "SEARCH")))))), _text38 || (_text38 = /*#__PURE__*/React.createElement("text", {
    x: 1072,
    y: 310,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "SEARCH")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-20"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1117,
    y: 297.05,
    width: 100,
    height: 17.73,
    rx: 2.66,
    ry: 2.66,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(#ffffff, var(--ge-dark-color, #121212))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 98,
      height: 1,
      paddingTop: 306,
      marginLeft: 1118
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font29 || (_font29 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Security/RBAC")))))), _text39 || (_text39 = /*#__PURE__*/React.createElement("text", {
    x: 1167,
    y: 310,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Security/RBAC")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-21"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1227,
    y: 297.05,
    width: 50,
    height: 17.73,
    rx: 2.66,
    ry: 2.66,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 48,
      height: 1,
      paddingTop: 306,
      marginLeft: 1228
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font30 || (_font30 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "CMS")))))), _text40 || (_text40 = /*#__PURE__*/React.createElement("text", {
    x: 1252,
    y: 310,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "CMS")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-22"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1037,
    y: 323.64,
    width: 50,
    height: 17.73,
    rx: 2.66,
    ry: 2.66,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 48,
      height: 1,
      paddingTop: 332,
      marginLeft: 1038
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font31 || (_font31 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "DMS")))))), _text41 || (_text41 = /*#__PURE__*/React.createElement("text", {
    x: 1062,
    y: 336,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "DMS")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-23"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1097,
    y: 323.64,
    width: 70,
    height: 17.73,
    rx: 2.66,
    ry: 2.66,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 68,
      height: 1,
      paddingTop: 332,
      marginLeft: 1098
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font32 || (_font32 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Workflows")))))), _text42 || (_text42 = /*#__PURE__*/React.createElement("text", {
    x: 1132,
    y: 336,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Workflows")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-24"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1177,
    y: 323.64,
    width: 80,
    height: 17.73,
    rx: 2.66,
    ry: 2.66,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 332,
      marginLeft: 1178
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font33 || (_font33 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Policy Engine")))))), _text43 || (_text43 = /*#__PURE__*/React.createElement("text", {
    x: 1217,
    y: 336,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Policy Engine")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-25"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1037,
    y: 350.23,
    width: 80,
    height: 17.73,
    rx: 2.66,
    ry: 2.66,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 78,
      height: 1,
      paddingTop: 359,
      marginLeft: 1038
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font34 || (_font34 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "ESB")))))), _text44 || (_text44 = /*#__PURE__*/React.createElement("text", {
    x: 1077,
    y: 363,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "ESB")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-26"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1139.5,
    y: 350.23,
    width: 55,
    height: 17.73,
    rx: 2.66,
    ry: 2.66,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 53,
      height: 1,
      paddingTop: 359,
      marginLeft: 1141
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font35 || (_font35 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Catalogue")))))), _text45 || (_text45 = /*#__PURE__*/React.createElement("text", {
    x: 1167,
    y: 363,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Catalogue")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-27"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1207,
    y: 350.23,
    width: 90,
    height: 17.73,
    rx: 2.66,
    ry: 2.66,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 88,
      height: 1,
      paddingTop: 359,
      marginLeft: 1208
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font36 || (_font36 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Change Central")))))), _text46 || (_text46 = /*#__PURE__*/React.createElement("text", {
    x: 1252,
    y: 363,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Change Central")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-28"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1037,
    y: 376.82,
    width: 90,
    height: 17.73,
    rx: 2.66,
    ry: 2.66,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 88,
      height: 1,
      paddingTop: 386,
      marginLeft: 1038
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font37 || (_font37 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Dataflow")))))), _text47 || (_text47 = /*#__PURE__*/React.createElement("text", {
    x: 1082,
    y: 389,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Dataflow")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-29"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1137,
    y: 376.82,
    width: 90,
    height: 17.73,
    rx: 2.66,
    ry: 2.66,
    fill: "#ffffff",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 88,
      height: 1,
      paddingTop: 386,
      marginLeft: 1138
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _font38 || (_font38 = /*#__PURE__*/React.createElement("font", {
    face: "poppins"
  }, "Lake")))))), _text48 || (_text48 = /*#__PURE__*/React.createElement("text", {
    x: 1182,
    y: 389,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Helvetica\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Lake")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-30"
  }, _g31 || (_g31 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1237,
    y: 372.39,
    width: 60,
    height: 26.59,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 58,
      height: 1,
      paddingTop: 386,
      marginLeft: 1238
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, "......")))), _text49 || (_text49 = /*#__PURE__*/React.createElement("text", {
    x: 1267,
    y: 389,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "......")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-31"
  }, _g32 || (_g32 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 935,
    y: 283.75,
    width: 90,
    height: 29.25,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 88,
      height: 1,
      paddingTop: 298,
      marginLeft: 936
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, _b2 || (_b2 = /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Reduced Dependencies"))))))), _text50 || (_text50 = /*#__PURE__*/React.createElement("text", {
    x: 980,
    y: 302,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Reduced Depende...")))))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-37"
  }, _g33 || (_g33 = /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-38"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1341,
    y: 56.75,
    width: 90,
    height: 358.5,
    rx: 13.5,
    ry: 13.5,
    fill: "#eee2e2",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(238, 226, 226), rgb(49, 38, 38))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-39"
  }, _g34 || (_g34 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1348.75,
    y: 68.97,
    width: 75,
    height: 24.44,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 73,
      height: 1,
      paddingTop: 81,
      marginLeft: 1350
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 8,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 14
    },
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins",
    face: "poppins"
  }, _b3 || (_b3 = /*#__PURE__*/React.createElement("b", null, "Data"))))))), _text51 || (_text51 = /*#__PURE__*/React.createElement("text", {
    x: 1386,
    y: 84,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "8px",
    textAnchor: "middle"
  }, "Data")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1363.75 103.49 C 1363.75 95.49 1408.75 95.49 1408.75 103.49 L 1408.75 140.38 C 1408.75 148.38 1363.75 148.38 1363.75 140.38 Z",
    fill: "#ffcce6",
    stroke: "#0066cc",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 204, 230), rgb(84, 40, 63))",
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1363.75 103.49 C 1363.75 109.49 1408.75 109.49 1408.75 103.49 M 1363.75 106.49 C 1363.75 112.49 1408.75 112.49 1408.75 106.49 M 1363.75 109.49 C 1363.75 115.49 1408.75 115.49 1408.75 109.49",
    fill: "none",
    stroke: "#0066cc",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 43,
      height: 1,
      paddingTop: 131,
      marginLeft: 1365
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {}
  }, /*#__PURE__*/React.createElement("b", {
    style: {}
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 10
    },
    face: "poppins"
  }, "Search")), _br5 || (_br5 = /*#__PURE__*/React.createElement("br", null))))))), _text52 || (_text52 = /*#__PURE__*/React.createElement("text", {
    x: 1386,
    y: 135,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "14px",
    textAnchor: "middle"
  }, "Search&#xa;")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1364.5 176.82 C 1364.5 168.82 1409.5 168.82 1409.5 176.82 L 1409.5 213.7 C 1409.5 221.7 1364.5 221.7 1364.5 213.7 Z",
    fill: "#ffcce6",
    stroke: "#0066cc",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 204, 230), rgb(84, 40, 63))",
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1364.5 176.82 C 1364.5 182.82 1409.5 182.82 1409.5 176.82 M 1364.5 179.82 C 1364.5 185.82 1409.5 185.82 1409.5 179.82 M 1364.5 182.82 C 1364.5 188.82 1409.5 188.82 1409.5 182.82",
    fill: "none",
    stroke: "#0066cc",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 43,
      height: 1,
      paddingTop: 204,
      marginLeft: 1366
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {}
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 10
    },
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, _b4 || (_b4 = /*#__PURE__*/React.createElement("b", null, "NoSql"))), _br6 || (_br6 = /*#__PURE__*/React.createElement("br", null))))))), _text53 || (_text53 = /*#__PURE__*/React.createElement("text", {
    x: 1387,
    y: 208,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "14px",
    textAnchor: "middle"
  }, "NoSql&#xa;")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-42"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1364.5 258.3 C 1364.5 250.3 1409.5 250.3 1409.5 258.3 L 1409.5 295.18 C 1409.5 303.18 1364.5 303.18 1364.5 295.18 Z",
    fill: "#ffcce6",
    stroke: "#0066cc",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 204, 230), rgb(84, 40, 63))",
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1364.5 258.3 C 1364.5 264.3 1409.5 264.3 1409.5 258.3 M 1364.5 261.3 C 1364.5 267.3 1409.5 267.3 1409.5 261.3 M 1364.5 264.3 C 1364.5 270.3 1409.5 270.3 1409.5 264.3",
    fill: "none",
    stroke: "#0066cc",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 43,
      height: 1,
      paddingTop: 286,
      marginLeft: 1366
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {}
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 10
    },
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, _b5 || (_b5 = /*#__PURE__*/React.createElement("b", null, "Cache"))), _br7 || (_br7 = /*#__PURE__*/React.createElement("br", null))))))), _text54 || (_text54 = /*#__PURE__*/React.createElement("text", {
    x: 1387,
    y: 290,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "14px",
    textAnchor: "middle"
  }, "Cache&#xa;")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-43"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1364.5 327.55 C 1364.5 319.55 1409.5 319.55 1409.5 327.55 L 1409.5 364.44 C 1409.5 372.44 1364.5 372.44 1364.5 364.44 Z",
    fill: "#ffcce6",
    stroke: "#0066cc",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 204, 230), rgb(84, 40, 63))",
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1364.5 327.55 C 1364.5 333.55 1409.5 333.55 1409.5 327.55 M 1364.5 330.55 C 1364.5 336.55 1409.5 336.55 1409.5 330.55 M 1364.5 333.55 C 1364.5 339.55 1409.5 339.55 1409.5 333.55",
    fill: "none",
    stroke: "#0066cc",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      stroke: "light-dark(rgb(0, 102, 204), rgb(86, 174, 255))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 43,
      height: 1,
      paddingTop: 355,
      marginLeft: 1366
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 14,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {}
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 10
    },
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, _b6 || (_b6 = /*#__PURE__*/React.createElement("b", null, "Graph"))), _br8 || (_br8 = /*#__PURE__*/React.createElement("br", null))))))), _text55 || (_text55 = /*#__PURE__*/React.createElement("text", {
    x: 1387,
    y: 359,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "14px",
    textAnchor: "middle"
  }, "Graph&#xa;")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-44"
  }, _g35 || (_g35 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1378.75,
    y: 378.59,
    width: 45,
    height: 24.44,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 43,
      height: 1,
      paddingTop: 391,
      marginLeft: 1380
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 6,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 24
    }
  }, "....."))))), _text56 || (_text56 = /*#__PURE__*/React.createElement("text", {
    x: 1401,
    y: 393,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "6px",
    textAnchor: "middle"
  }, "....."))))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-45"
  }, _g36 || (_g36 = /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-46"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 817,
    y: 50,
    width: 80,
    height: 380,
    rx: 12,
    ry: 12,
    fill: "#eee2e2",
    stroke: "#000000",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(238, 226, 226), rgb(49, 38, 38))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-47"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 828.79 70 L 883.21 70 L 883.21 124.42 L 828.79 124.42 Z",
    fill: "#eee2e2",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(238, 226, 226), rgb(49, 38, 38))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 851.64 79.52 C 851.81 79.52 851.94 79.66 851.94 79.83 C 851.94 80 851.81 80.13 851.64 80.13 C 851.47 80.13 851.33 80 851.33 79.83 C 851.33 79.66 851.47 79.52 851.64 79.52 Z M 851.64 81.62 C 852.63 81.62 853.43 80.82 853.43 79.83 C 853.43 78.84 852.63 78.03 851.64 78.03 C 850.65 78.03 849.84 78.84 849.84 79.83 C 849.84 80.82 850.65 81.62 851.64 81.62 Z M 855.02 80.81 L 860.35 80.81 L 860.35 78.82 L 855.02 78.82 Z M 864.12 116.99 L 847.87 116.99 C 846.88 116.99 846.07 116.2 846.07 115.23 L 846.07 113.83 L 865.93 113.83 L 865.93 115.23 C 865.93 116.2 865.12 116.99 864.12 116.99 Z M 846.07 84.19 L 865.93 84.19 L 865.93 111.84 L 846.07 111.84 L 846.07 102.21 Z M 848.7 77.43 L 863.3 77.43 C 864.75 77.43 865.93 78.59 865.93 80.01 L 865.93 82.2 L 846.07 82.2 L 846.07 80.01 C 846.07 78.59 847.25 77.43 848.7 77.43 Z M 863.31 75.44 L 863.3 75.44 L 848.7 75.44 C 846.16 75.44 844.09 77.49 844.09 80.01 L 844.09 115.23 C 844.09 117.29 845.78 118.98 847.87 118.98 L 864.12 118.98 C 866.21 118.98 867.91 117.29 867.91 115.23 L 867.91 80.01 L 867.91 80.01 C 867.91 77.5 865.85 75.45 863.31 75.44 Z",
    fill: "#232f3e",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(35, 47, 62), rgb(189, 199, 212))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 131,
      marginLeft: 856
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#232F3E"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#232F3E, #bdc7d4)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, _font39 || (_font39 = /*#__PURE__*/React.createElement("font", {
    face: "poppins"
  }, "Mobile client")))))), _text57 || (_text57 = /*#__PURE__*/React.createElement("text", {
    x: 856,
    y: 143,
    fill: "#232F3E",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Mobile cl...")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-48"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 835.15 160 L 880.5 160 L 880.5 205.35 L 835.15 205.35 Z",
    fill: "url(#drawio-svg-MqirY2T3EYL537KwJXKP-gradient-light-dark_f54749_ff7072_-1-light-dark_ffccff_512551_-1-s-0)",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "url(&quot"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 870.51 195.34 L 857.51 170 L 861.22 170 L 874.23 195.34 Z M 875.86 195.69 L 862.2 169.06 C 862.09 168.85 861.86 168.71 861.62 168.71 L 856.45 168.71 C 856.22 168.71 856.01 168.83 855.89 169.02 C 855.78 169.21 855.77 169.45 855.87 169.65 L 869.54 196.28 C 869.65 196.5 869.87 196.63 870.11 196.63 L 875.29 196.63 C 875.51 196.63 875.72 196.52 875.84 196.32 C 875.95 196.13 875.96 195.89 875.86 195.69 Z M 862.74 195.34 L 852.79 176.69 L 854.83 173.32 L 866.45 195.34 Z M 855.44 171.7 C 855.33 171.49 855.12 171.36 854.88 171.36 C 854.66 171.34 854.43 171.47 854.31 171.67 L 851.49 176.33 C 851.37 176.53 851.37 176.77 851.47 176.97 L 861.78 196.29 C 861.89 196.5 862.11 196.63 862.35 196.63 L 867.52 196.63 C 867.75 196.63 867.96 196.52 868.08 196.32 C 868.2 196.13 868.2 195.89 868.1 195.69 Z M 841.51 195.34 L 850.64 180.25 L 852.5 183.73 L 848.21 191.14 C 848.09 191.34 848.09 191.58 848.21 191.78 C 848.33 191.98 848.54 192.11 848.77 192.11 L 856.96 192.11 L 858.69 195.34 Z M 857.92 191.16 C 857.81 190.95 857.59 190.81 857.35 190.81 L 849.89 190.81 L 853.79 184.07 C 853.91 183.88 853.91 183.64 853.81 183.44 L 851.24 178.63 C 851.13 178.43 850.92 178.3 850.69 178.29 C 850.44 178.28 850.24 178.41 850.12 178.6 L 839.81 195.65 C 839.69 195.85 839.68 196.1 839.8 196.31 C 839.91 196.51 840.13 196.63 840.36 196.63 L 859.76 196.63 C 859.99 196.63 860.2 196.52 860.32 196.32 C 860.44 196.13 860.44 195.88 860.33 195.68 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 212,
      marginLeft: 858
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#232F3E"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#232F3E, #bdc7d4)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, _font40 || (_font40 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Applications")))))), _text58 || (_text58 = /*#__PURE__*/React.createElement("text", {
    x: 858,
    y: 224,
    fill: "#232F3E",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Applica...")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-49"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 837.87 260 L 877.78 260 L 877.78 299.91 L 837.87 299.91 Z",
    fill: "url(#drawio-svg-MqirY2T3EYL537KwJXKP-gradient-light-dark_f34482_ff6ba1_-1-light-dark_ffccff_512551_-1-s-0)",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "url(&quot"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 841.86 281.72 L 843.04 281.72 L 843.04 280.54 L 841.86 280.54 Z M 862.53 271.49 C 862.45 271.25 862.22 271.08 861.96 271.08 L 861.96 271.08 C 861.7 271.08 861.48 271.24 861.4 271.49 L 857.68 283.17 L 854.21 276.71 C 854.1 276.52 853.91 276.4 853.69 276.4 L 853.68 276.4 C 853.47 276.4 853.28 276.51 853.17 276.7 L 850.98 280.54 L 844.23 280.54 L 844.23 281.72 L 851.32 281.72 C 851.53 281.72 851.73 281.6 851.83 281.42 L 853.67 278.21 L 857.3 284.95 C 857.41 285.15 857.61 285.27 857.82 285.27 C 857.84 285.27 857.86 285.26 857.88 285.26 C 858.11 285.24 858.31 285.08 858.39 284.85 L 861.96 273.63 L 864.35 281.3 C 864.43 281.55 864.66 281.72 864.92 281.72 L 873.79 281.72 L 873.79 280.54 L 865.35 280.54 Z M 857.83 293.76 L 849.31 282.77 L 848.38 283.5 L 857.36 295.09 C 857.47 295.23 857.63 295.34 857.82 295.31 C 858.01 295.31 858.18 295.23 858.29 295.09 L 867.33 283.5 L 866.4 282.77 Z M 842.88 276.45 C 842.2 275.19 841.86 273.94 841.86 272.68 C 841.86 268.21 845.58 264.57 850.16 264.57 C 853.82 264.57 856.65 266.23 857.82 268.83 C 859 266.23 861.83 264.57 865.49 264.57 C 870.06 264.57 873.79 268.21 873.79 272.68 C 873.79 273.91 873.46 275.15 872.82 276.36 C 872.63 276.71 872.41 277.07 872.13 277.44 L 871.61 278.06 L 870.09 279.75 L 869.21 278.96 L 871.2 276.71 C 871.42 276.41 871.62 276.11 871.78 275.81 C 872.33 274.77 872.6 273.72 872.6 272.68 C 872.6 268.86 869.41 265.76 865.49 265.76 C 861.97 265.76 858.41 267.59 858.41 271.67 C 858.41 272 858.15 272.26 857.82 272.26 C 857.5 272.26 857.23 272 857.23 271.67 C 857.23 267.59 853.68 265.76 850.16 265.76 C 846.24 265.76 843.04 268.86 843.04 272.68 C 843.04 273.74 843.33 274.81 843.89 275.84 L 845.91 278.99 L 844.91 279.62 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 307,
      marginLeft: 858
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#232F3E"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#232F3E, #bdc7d4)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, _font41 || (_font41 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Dashboards")))))), _text59 || (_text59 = /*#__PURE__*/React.createElement("text", {
    x: 858,
    y: 319,
    fill: "#232F3E",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Dashbo...")))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-51"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 834.24 350 L 877.77 350 L 877.77 393.54 L 834.24 393.54 Z",
    fill: "url(#drawio-svg-MqirY2T3EYL537KwJXKP-gradient-light-dark_f78e04_b85e00_-1-light-dark_d05c17_e07c41_-1-s-0)",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "url(&quot"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 864.8 360 L 869.6 360 L 869.6 358.75 L 864.8 358.75 Z M 864.09 356.8 L 870.31 356.8 L 870.31 355.55 L 864.09 355.55 Z M 864.71 373.63 L 869.69 373.63 L 869.69 372.39 L 864.71 372.39 Z M 864.09 376.74 L 870.31 376.74 L 870.31 375.5 L 864.09 375.5 Z M 852.09 375.94 C 852.34 375.7 852.34 375.3 852.09 375.06 L 844.63 367.6 L 843.75 368.48 L 850.77 375.5 L 843.75 382.52 L 844.63 383.4 Z M 852.28 382.96 L 864.71 382.96 L 864.71 381.72 L 852.28 381.72 Z M 873.42 387.94 L 873.42 381.72 L 872.18 381.72 L 872.18 387.94 L 839.84 387.94 L 839.84 355.6 L 857.25 355.6 L 857.25 354.36 L 839.84 354.36 C 839.15 354.36 838.59 354.91 838.59 355.6 L 838.59 387.94 C 838.59 388.63 839.15 389.18 839.84 389.18 L 872.18 389.18 C 872.86 389.18 873.42 388.63 873.42 387.94 Z M 862.23 375.32 C 862.22 373.45 862.93 371.65 864.21 370.29 L 871.1 362.9 C 872.6 361.3 873.42 359.21 873.42 357.02 L 873.42 354.36 L 872.18 354.36 L 872.18 357.02 C 872.18 358.89 871.47 360.69 870.19 362.05 L 863.3 369.44 C 861.81 371.04 860.98 373.13 860.98 375.32 L 860.98 377.99 L 862.23 377.99 Z M 868.9 367.08 L 868.05 367.99 L 870.19 370.29 C 871.47 371.65 872.18 373.45 872.18 375.32 L 872.18 377.99 L 873.42 377.99 L 873.42 375.32 C 873.42 373.13 872.6 371.04 871.1 369.44 Z M 863.3 362.9 C 861.81 361.3 860.98 359.21 860.98 357.02 L 860.98 354.36 L 862.23 354.36 L 862.23 357.02 C 862.22 358.89 862.93 360.69 864.21 362.05 L 866.35 364.35 L 865.5 365.26 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(255, 255, 255), rgb(18, 18, 18))"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 401,
      marginLeft: 856
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#232F3E"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#232F3E, #bdc7d4)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, _font42 || (_font42 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "CLI")))))), _text60 || (_text60 = /*#__PURE__*/React.createElement("text", {
    x: 856,
    y: 413,
    fill: "#232F3E",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "CLI")))))))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "0gBn-n4TOAm3gDtEJDbB-32"
  }, _g37 || (_g37 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 939,
    y: 435,
    width: 330,
    height: 40,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible",
      textAlign: "left"
    },
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 328,
      height: 1,
      paddingTop: 455,
      marginLeft: 940
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center",
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "&quot",
      color: "light-dark(#000000, #ffffff)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      wordWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 24
    }
  }, _font43 || (_font43 = /*#__PURE__*/React.createElement("font", {
    face: "poppins",
    "data-font-src": "https://fonts.googleapis.com/css?family=poppins"
  }, "Cloud Native")), _br9 || (_br9 = /*#__PURE__*/React.createElement("br", null))))))), _text61 || (_text61 = /*#__PURE__*/React.createElement("text", {
    x: 1104,
    y: 459,
    fill: "light-dark(#000000, #ffffff)",
    fontFamily: "\"Comic Sans MS\"",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Cloud Native&#xa;")))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiNativeTransformationdrawio);
export default __webpack_public_path__ + "static/media/AINativeTransformation.drawio.612087636883134cdc02be85624128b2.svg";
export { ForwardRef as ReactComponent };